import styled from "@emotion/styled";
import { Icon } from "@gumtree/ui-library";
import {
    colors,
    colorVariables,
    fontSizes,
    gutterSizes,
    zIndexes,
    mediaQuery,
    breakpoints,
} from "@gumtree/ui-library/src/base/theme";

const shouldForwardProp = (p: string) => !["isOpen"].includes(p);

export const StyledContent = styled("div", {
    shouldForwardProp,
})<{
    isOpen: boolean;
}>`
    background-color: ${colors.white};
    z-index: ${zIndexes.high - 1};
    transition: transform 0.2s;
    transition-timing-function: linear;
    position: fixed;
    overflow: auto;
    ${(props) => `
        transform: translateX(${props.isOpen ? "0" : "100%"});
    `};

    ${mediaQuery.until(breakpoints.large)} {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    ${mediaQuery.from(breakpoints.large)} {
        top: calc((100vh - 768px) / 2);
        width: calc(618px - ${gutterSizes.xxlarge} * 2);
        height: calc(768px - ${gutterSizes.large} * 2);
        padding: ${gutterSizes.large} ${gutterSizes.xxlarge};
        border-radius: ${gutterSizes.base};
        ${(props) => `
            display: ${props.isOpen ? "block" : "none"};
        `};
    }
`;

export const StyledHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid ${colorVariables.borderLight};
    padding: 20px ${gutterSizes.large};
`;

export const StyledTitle = styled.h2`
    width: 100%;
    margin: 0 0 0 ${gutterSizes.large18};
    font-size: ${fontSizes.xlarge};
`;

export const StyledList = styled.div`
    display: flex;
    flex-direction: column;
    padding: ${gutterSizes.large18} ${gutterSizes.large};
    ${mediaQuery.until(breakpoints.medium)} {
        padding-bottom: 100px;
    }
`;

export const StyledIcon = styled(Icon)`
    position: relative;
    top: -2px;
    color: ${colors.darkGrey};
    cursor: pointer;
`;
